import { client as elevioClient } from 'elevio';
import { AnalyticsMenu, AnalyticsMenuAction } from 'lib-analytics-ui';
import { ampli } from 'lib-shared-tracking';
import { memo, useMemo } from 'react';

import { appActions } from 'app/app.actions';
import { AppLink } from 'components/appLink';
import { articles } from 'utils/elevio';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { useDashboardLastRefresh } from '../../../../utils/useDashboardLastRefresh';

import { FavoriteDashboardPreferencesControl } from './components/preferences/favoriteDashboardPreferencesControl';

export const FavoriteDashboardControls = memo(
  function FavoriteDashboardControls(): JSX.Element {
    const dispatch = useAppDispatch();

    const { refreshAction } = useDashboardLastRefresh({
      dashboardType: 'favorite',
    });

    const actions = useMemo(
      (): AnalyticsMenuAction[] => [
        refreshAction,
        {
          type: 'divider',
        },
        {
          type: 'link',
          label: 'TV mode',
          icon: 'presentation',
          link: <AppLink path="/tv/dashboard/organization" />,
          onClick: () => {
            ampli.dashboardGlobalTvDashboardClicked();
          },
        },
        {
          type: 'divider',
        },
        {
          type: 'button',
          label: 'Send feedback',
          icon: 'paper-plane',
          onClick: () => {
            dispatch(
              appActions.showModal({
                modal: {
                  type: 'app:feedbackForm',
                  arg: {
                    title: 'Dashboard Feedback',
                    team: 'insights',
                    extra: {
                      dashboard: 'favorites',
                    },
                  },
                },
              }),
            );
          },
        },
        {
          type: 'button',
          label: 'Help and documentation',
          icon: 'question',
          onClick: () => {
            elevioClient.openArticle(
              articles.dashboard.favorites.documentation,
            );
          },
        },
      ],
      [dispatch, refreshAction],
    );

    return (
      <>
        <FavoriteDashboardPreferencesControl />

        <AnalyticsMenu actions={actions} />
      </>
    );
  },
);
